export const Layer = {
  PhotoGalleryPopup: 5000,
  VideoPopup: 4000,
  FullscreenMenu: 3000,
  AlertBar: 2000,
  LanguageSwitch: 1000,
  Default: 0,
}
